import { useContext } from 'react';
import { assign } from 'xstate';
import { useInterpret } from '@xstate/react';
import { DataAccessContext } from '@chargify/data-access';
import {
  PauseSubscriptionEvent,
  SetErrorEvent,
  SetSubscriptionStatusEvent,
  pauseSubscription,
} from '../machines/pauseSubscription';
import { GlobalStateContext } from '../contexts';

export const usePauseSubscriptionService = (
  catalogId: number,
  subscriptionId: number
) => {
  const { dataAccess } = useContext(DataAccessContext);
  const { subscriptionsService } = useContext(GlobalStateContext);
  return useInterpret(pauseSubscription, {
    services: {
      pauseSubscription: (_ctx, payload: PauseSubscriptionEvent) => {
        return dataAccess.pauseSubscription(
          payload.subscriptionId,
          payload.automaticallyResumeAt
        );
      },
    },
    actions: {
      updateSubscription: (_ctx, payload: SetSubscriptionStatusEvent) => {
        const {
          data: { automaticallyResumeAt, state },
        } = payload;
        subscriptionsService.send({
          type: 'UPDATE_SUBSCRIPTION',
          subscriptionId,
          catalogId,
          automaticallyResumeAt,
          status: state,
        });
      },
      setError: assign((context, event: SetErrorEvent) => {
        return {
          ...context,
          error: event.data,
        };
      }),
    },
  });
};

export type PauseSubscriptionService = ReturnType<
  typeof usePauseSubscriptionService
>;
